// Generated by CoffeeScript 2.7.0
var Form;

import BaseModel from './base_model.js';

import Fieldable from './concerns/fieldable.js';

import UserBoundary from './user_boundary.js';

export default Form = (function() {
  class Form extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
      this.user_boundary = new UserBoundary(_.extend({}, attrs.user_boundary));
      this._makeFields(attrs.fields, this.logic_settings);
    }

    toJSON() {
      return _.extend(super.toJSON(), {
        fields_attributes: this._generateFieldAttributes(),
        user_boundary_attributes: this.user_boundary.toJSON(),
        // TODO: model red_packet_setting
        red_packet_setting_attributes: this.red_packet_setting
      });
    }

  };

  Form.setAttributes(['status', 'title', 'description', 'submit_once', 'step_renderable', 'after_submit_action', 'after_submit_show_message', 'after_submit_redirect_url', 'success_message', 'settings', 'tag_ids', 'anonymous_allowed', 'closed_at', 'comment_status', 'enable_appendable', 'push_agent_on_publish_attributes', 'response_required', 'responses_limit', 'published_as_id', 'namecard_id', 'closed', 'admin', 'attachment_ids', 'attachments', 'logic_settings']);

  return Form;

}).call(this);

Form.assemble(Fieldable);
